import React from 'react'
import Navbar from '../../components/companyLandingComponents/Navbar/Navbar'
import FooterSection from '../../components/Footer/Footer'
import { Outlet } from 'react-router-dom'

const HomeLayout = () => {
  return (
    <>
      <Navbar/>
      <main>
         <Outlet />
      </main>
      <FooterSection/>
    </>
  )
}

export default HomeLayout
